

























































import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";

@Component
export default class ComboBoxSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: () => [] as any[] })
  options: any[];

  @Prop({ default: false })
  isNumberOnly: boolean;

  @Prop({ default: false })
  isNuturalNumberOnly: boolean;

  // IEの×ボタンの表示有無を変える（Chromeは差異無し）
  @Prop({ default: true })
  isClearable: boolean;

  @Prop({ default: false })
  shouldBeLazy: boolean;

  @Emit()
  onInputFocused(): void {}

  data(): any {
    return {
      expand: false,
      selected: null,
    };
  }
  expand: boolean;
  selected: any;

  hideExpandTimer: number;

  $refs!: {
    input: HTMLInputElement;
    ul: HTMLUListElement;
  };

  mounted() {
    this.updateSelectedWithSource();
  }

  get maxCount(): number {
    return Math.min(this.options.length, 10);
  }

  get inputType(): string {
    return this.isNumberOnly ? "number" : "text";
  }

  onInputKeyDownArrowUp(event: KeyboardEvent) {
    // type="number"だとChromeでは上下矢印キーで値が増減する（上：プラス１、下：マイナス１）
    // オプションの中身が昇順の場合、上矢印キーを押したときはマイナス１してほしいのにプラス１されるので
    // イベントをストップさせる（IEはもともと上下矢印キーでの増減なし）
    event.stopPropagation();
    event.preventDefault();
  }

  onInputKeyDownArrowDown(event: KeyboardEvent) {
    // type="number"だとChromeでは上下矢印キーで値が増減する（上：プラス１、下：マイナス１）
    // オプションの中身が昇順の場合、上矢印キーを押したときはマイナス１してほしいのにプラス１されるので
    // イベントをストップさせる（IEはもともと上下矢印キーでの増減なし）
    event.stopPropagation();
    event.preventDefault();
  }

  onInputBlur() {
    this.hideExpand();
  }

  onInputClick() {
    this.toggleExpand();
  }

  onInputKeyupUp() {
    this.showExpand();
    this.$nextTick(() => this.focusSelect());
  }

  onInputKeyupDown() {
    this.showExpand();
    this.$nextTick(() => this.focusSelect());
  }

  onInputKeyupEsc() {
    this.hideExpand();
  }

  onUlKeyDownArrowUp() {
    this.selectPreviousOption();
    this.adjustScrollTop();
  }

  onUlKeyDownArrowDown() {
    this.selectNextOption();
    this.adjustScrollTop();
  }

  selectPreviousOption() {
    const selectedIndex = this.options.indexOf(this.selected);
    if (selectedIndex === 0) { return; }
    const previousIndex = selectedIndex - 1;
    if (this.options.length >= previousIndex) {
      this.editingSource = this.options[previousIndex];
    }
  }

  selectNextOption() {
    const selectedIndex = this.options.indexOf(this.selected);
    const nextIndex = selectedIndex + 1;
    if (this.options.length === nextIndex) { return; }
    if (this.options.length > nextIndex) {
      this.editingSource = this.options[nextIndex];
    }
  }

  onListFocus() {
    this.showExpand();
  }

  onListBlur() {
    this.hideExpand();
  }

  onListClick(index: number) {
    const target = this.options[index];
    this.selected = this.isNumberOnly
      ? Number(target)
      : target;
    this.updateSourceWithSelected();
    this.focusInput();
  }

  onListKeyupEnter() {
    this.updateSourceWithSelected();
    this.focusInput();
  }

  onListKeyupEsc() {
    this.focusInput();
  }

  onInputFocus() {
    this.onInputFocused();
  }

  private focusSelect() {
    if (this.$refs.ul) {
      this.$refs.ul.focus();
    }
    this.$nextTick(() => this.updateSelectedWithSource());
  }

  private focusInput() {
    if (this.$refs.input) {
      this.$refs.input.focus();
    }
  }

  private showExpand() {
    clearTimeout(this.hideExpandTimer);
    this.expand = true;
  }

  private hideExpand() {
    this.hideExpandTimer = setTimeout(() => this.expand = false);
  }

  private toggleExpand() {
    if (this.expand) {
      this.hideExpand();
    } else {
      this.showExpand();
    }
  }

  private updateSelectedWithSource() {
    if (this.editingSource) {
      this.selected = this.editingSource;
    } else if (this.options.length > 0) {
      this.selected = this.options[0];
    }
  }

  private updateSourceWithSelected() {
    if (this.selected || this.selected === 0) {
      this.editingSource = this.selected;
    }
  }

  get inputClassName(): string {
    return this.isClearable ? "" : "clearless";
  }

  get selectedListIndex(): number {
    const selectedValue = this.isNumberOnly ? Number(this.selected) : this.selected;
    return this.options.indexOf(selectedValue);
  }

  selectAllInputText(): void {
    if (this.$refs.input) {
      this.$refs.input.select();
    }
  }

  adjustScrollTop(): void {
    if (this.selectedListIndex < 0) { return; }
    if (!this.$refs.ul) { return; }
    const itemClientHeight = this.$refs.ul.scrollHeight / this.options.length;
    // 選択項目を真ん中に表示する（選択項目より小さい値が無ければ１番下に、大きい値が無ければ１番上に表示）
    this.$refs.ul.scrollTop = this.selectedListIndex === (this.options.length - 1) 
      ? this.$refs.ul.scrollHeight - itemClientHeight
      : (itemClientHeight * (this.selectedListIndex - (Math.round(this.maxCount / 2) - 1)));
  }

  getListClassName(index: number): string {
    return this.selectedListIndex === index
      ? "list-selected"
      : "list-unselected";
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: any, oldValue: any) {
    if (this.isNuturalNumberOnly && newValue && !isNaN(newValue)) {
      const replaceValue = newValue.toString().replace(/^-/, "");
      const floorValue = Math.floor(Number(replaceValue));
      if (newValue !== floorValue) {
        this.editingSource = floorValue;
      }
    }
    if (this.selected !== newValue) {
      this.updateSelectedWithSource();
    }
  }

  @Watch("expand")
  onExpandUpdated(newValue: boolean, oldValue: boolean) {
    if (!newValue) { return; }
    this.$nextTick(() => {
      this.adjustScrollTop();
    });
  }

  @Watch("options")
  onOptionsUpdated(newValue: any[], oldValue: any[]) {
    this.$nextTick(() => {
      this.adjustScrollTop();
    });
  }
}
